import requestAction from '../../utils/requestAction'
import ProductSection from '../../models/ProductSection';

export const upsertProductSection = (productSection: (ProductSection)) =>
  requestAction('PRODUCTSECTION_UPSERT')(
    `productSections${(productSection as ProductSection).id ? `/${(productSection as ProductSection).id}` : ''}`,
    (productSection as ProductSection).id ? 'PUT' : 'POST',
    productSection
  )
